import script from "./VersionInfo.vue?vue&type=script&setup=true&lang=ts"
export * from "./VersionInfo.vue?vue&type=script&setup=true&lang=ts"

import "./VersionInfo.vue?vue&type=style&index=0&id=4b5befe4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b5befe4"]])

export default __exports__